import { createSlice } from "@reduxjs/toolkit";
import { fetchArchiveServicesStudentData,updateMergeDataToActualData } from "../thunks/archiveServicesThunk";

const archiveServicesEnrolmentSlice = createSlice({
  name: "archiveServicesEnrolment",
  initialState: {
    data: [{
            "regionType": "",
            "regionCode": "",
            "yearId": "11",
            "location": "India",
            "rural_urban": "Urban",
            "school_management": "School mgt.",
            "school_type": "School Type.",
            "no_of_headmaster": 0,
    }],
    isLoading:true,
    isError:false,
    error:null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchiveServicesStudentData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchArchiveServicesStudentData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchiveServicesStudentData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(updateMergeDataToActualData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
  },
});

export default archiveServicesEnrolmentSlice.reducer;